import PageHeader from "app/shared/PageHeader";
import "./Hotels.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { tabViewStates, userInfo } from "app/config/States/users";

import {
  Button,
  Dropdown,
  Input,
  message,
  Modal,
  Select,
  Tabs,
  Tag,
} from "antd";

import {
  API_ENDPOINT_FETCH_AIRLINE_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST,
  API_ENDPOINT_FETCH_EMAIL_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST,
} from "../Credentials/credentials.constants";
import { apiGet, apiPost } from "app/services/apiServices";

import Loader from "app/shared/Loader";
import HotelRecon from "./components/HotelRecon";
import UnReconciledFlight from "../AppTour/components/OnboardUnReconcilied/UnReconciledFlight";
import TableViewManager from "app/shared/TableViewManager";
import { API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST } from "../Reconcilation/reconcilation.constants";
import { useFetcher } from "react-router-dom";
import EmptyState from "app/shared/EmptyState";
import { agTableRowSize } from "app/config/States/agtable";
import {
  appMetaConfig,
  DASHBOARD_LINK_ZOHO_CRITERIA_FILTER,
} from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import BulkDownloadWidget from "app/shared/BulkDownloadWidget";
import ReportHistory from "../Flights/components/ReportsHistory";
import { Mixpanel } from "app/config/Mixpanel";
export default function Flights(props: any) {
  const [activeTab, setActiveTab] = useState("1");
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const reconPageRef: any = useRef();
  const [showModal, setShowModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [creatingRequest, setCreatingRequest] = useState(false);
  const [showModelFor, setShowModalFor] = useState("");
  const [reportName, setReportName] = useState("");
  const [tableRowSize, setTableRowSize] = useRecoilState<any>(agTableRowSize);
  const domain = getSubdomain();
  useEffect(() => {
    Mixpanel.track("User Landed On Hotel Recon", { Screen: "Hotel Recon" });

    if (
      activeTab === "1" &&
      userDetails?.currentWorkspace?.name !== "MMT Admin"
    ) {
      setActiveTab("1");
    }
  }, [userDetails?.currentWorkspace]);
  const getSceneItems = () => {
    return [
      {
        key: "1",
        label: "Dashboard",
      },
      {
        key: "2",
        label: "Reconciliation",
      },
    ];
  };

  const renderScene = () => {
    switch (activeTab) {
      case "2":
        return (
          <HotelRecon
            ref={reconPageRef}
            moduleId={appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_MMT"}
          />
        );
      default:
        return <HotelRecon />;
    }
  };

  const handleRaiseReportRequest = async () => {
    setCreatingRequest(true);

    let tablePayload =
      (await reconPageRef.current) && reconPageRef.current?.getGridState();
    let payload = {
      moduleId: appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_ONE",
      table_name: appMetaConfig[domain]?.hotel_recon_table,
      name: reportName,
      email: userDetails?.email,
      type: "HOTEL",
      tablePayload: tablePayload,
      workspaceid:
        userDetails.currentWorkspace?.id ||
        localStorage.getItem("currentWorkspace"),
    };

    const response = await apiPost(
      API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST,
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        content: "We will notify you via email once report is ready",
      });
    }
    setCreatingRequest(false);
    setShowModal(false);
    setShowModalFor("");
    setReportName("");
  };
  const handleViewReports = async (report: any) => {
    if (report.key === "1") {
      reconPageRef.current && reconPageRef.current.exportDataToExcel();
      // setShowModalFor("CREATE");
    } else {
      setShowModalFor("HISTORY");
    }
    setShowModal(true);
  };

  const encodedWorkspaceName = encodeURIComponent(
    userDetails.currentWorkspace?.name
  );

  return (
    <div className="Hotels">
      <div className="ScreenContainer">
        <PageHeader
          leftActions={
            <Tabs
              items={getSceneItems()}
              tabBarStyle={{
                borderBottom: "none",
                margin: 0, // Remove the underline border
              }}
              activeKey={activeTab}
              onChange={(tabItem: string) => setActiveTab(tabItem)}
            />
          }
        />

        <div className="TableContainer">
          {activeTab === "1" ? (
            <iframe
              height="100%"
              style={{ width: "100%" }}
              scrolling="no"
              title="Iframe"
              id="dashboardFrame"
              src={`https://analytics.zoho.in/open-view/103074000035887191/59fe30ed78db34d9dedc6e5d368bc83c?ZOHO_CRITERIA=%22${DASHBOARD_LINK_ZOHO_CRITERIA_FILTER[domain]?.["1"]}%22%3D%27${encodedWorkspaceName}%27`}
            ></iframe>
          ) : (
            <iframe
              height="100%"
              style={{ width: "100%" }}
              scrolling="no"
              title="Iframe"
              id="dashboardFrame"
              src={`https://analytics.zoho.in/open-view/103074000031607926?ZOHO_CRITERIA=%22Hotel%20Report%20Naman%22.%22Workspace%22%3D%27NetApp%27`}
            ></iframe>
          )}
        </div>

        <Modal
          open={showModal}
          footer={false}
          onCancel={() => setShowModal(false)}
          title={
            showModelFor === "CREATE"
              ? "Create Report Request"
              : "Report Download History"
          }
          width={showModelFor === "CREATE" ? 500 : 800}
        >
          {showModelFor === "CREATE" ? (
            <>
              <Input
                placeholder="Report Name"
                onChange={(e: any) => setReportName(e.target.value)}
                value={reportName}
              />
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{ marginRight: 12 }}
                  onClick={() => setShowModal(false)}
                  loading={creatingRequest}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleRaiseReportRequest}
                  type="primary"
                  loading={creatingRequest}
                >
                  Create
                </Button>
              </div>
            </>
          ) : (
            <ReportHistory
              moduleId={appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_MMT"}
            />
          )}
        </Modal>
      </div>
      {contextHolder}
    </div>
  );
}
